import React from 'react';
import CategoryPage from '../../categories/CategoryPage';

function Anexo30Y31Ano2023EvidenciasFotograficas() {
  return <CategoryPage category="anexo30Y31Ano2023EvidenciasFotograficas" pageTitle="Evidencias Fotograficas 2023" />;
}

export default Anexo30Y31Ano2023EvidenciasFotograficas;
